import { render, staticRenderFns } from "./CreativesTable.vue?vue&type=template&id=7c1c24c2&scoped=true&"
import script from "./CreativesTable.vue?vue&type=script&lang=js&"
export * from "./CreativesTable.vue?vue&type=script&lang=js&"
import style0 from "./CreativesTable.vue?vue&type=style&index=0&id=7c1c24c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c24c2",
  null
  
)

export default component.exports